<script setup lang="ts">
const appStore = useAppStore();
</script>

<template>
  <div class="app-body">
    <main>
      <!-- IM -->
      <!-- <IM /> -->
      <RouterView v-slot="{ Component }">
        <Transition name="fade" mode="out-in">
          <component :is="Component" />
        </Transition>
      </RouterView>

      <MessageBox />
    </main>

    <SMSVerifyPopup v-model:dialogVisible="appStore.isShowSMSVerifyPopup" />
    <GetCouponPopup v-model:dialogVisible="appStore.isShowGetCouponPopup" />
  </div>
</template>
<style scoped lang="scss"></style>
